export { default as lightPalette } from './light'
export { default as darkPalette } from './dark'
export { default as staticColors } from './static'
export type { ColorPalette, StaticColors } from './types'
